import React from 'react';
import { WrenchScrewdriverIcon } from '@heroicons/react/24/outline';

export default function Maintenance({ message }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-honey-50 to-slate-100 flex flex-col items-center justify-center px-4 py-12">
      <div className="max-w-lg w-full text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-honey-100 text-honey-600 mb-6">
          <WrenchScrewdriverIcon className="h-8 w-8" aria-hidden />
        </div>
        <h1 className="text-3xl font-bold text-slate-900 mb-3">Abeille Réunion</h1>
        <p className="text-lg font-medium text-honey-600 mb-4">Maintenance en cours</p>
        <p className="text-slate-600 leading-relaxed whitespace-pre-line">
          {message}
        </p>
      </div>
    </div>
  );
}
